<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Filter :button="filterConfig.buttonConfig" />

    <div class="table-data">
      <table class="table table-hover table-responsive">
        <thead class="table-light">
          <tr>
            <th scope="col" width="250">ID</th>
            <th scope="col" width="250">Title</th>
            <th scope="col" width="250">Parent Asset</th>
            <th scope="col" width="250">Asset Type</th>
            <th scope="col">
              <span class="d-flex justify-content-end">
                <tableHeadingIcon />
              </span>

            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in tableData" :key="index">
            <td>{{ item.id }}</td>
            <td v-if="item.title === ''">-</td>
            <td v-else>{{ item.title }}</td>
            <td v-if="item.parentassettitle === ''">-</td>
            <td v-else>{{ item.parentassettitle }}</td>
            <td v-if="(item.assettypetitle === null) || (item.assettypetitle === '')">-</td>
            <td v-else>{{ item.assettypetitle.toString() }}</td>
            <td>
              <router-link :to="`/iotassets/asset/edit/${item.uuid}`">
                <span class="d-flex justify-content-end">
                  <editIcon />
                </span>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pagination-container">
        <div class="items-per-page">
          <label for="itemsPerPage">Records Per Page:</label>
          <select id="itemsPerPage" class="items-per-page-dropdown" v-model="pageSize" @change="changePageSize">
            <option v-for="option in pageSizeOptions" :value="option">{{ option }}</option>
          </select>
        </div>
        <div class="total-entries">
          <span>Total Records: {{ totalCount }}</span>
        </div>
        <div class="pagination">
          <ul class="pagination-list">
            <li @click="gotoPage(1)"><a><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                  fill="currentColor" class="bi bi-skip-start-fill" viewBox="0 0 16 16">
                  <path
                    d="M4 4a.5.5 0 0 1 1 0v3.248l6.267-3.636c.54-.313 1.232.066 1.232.696v7.384c0 .63-.692 1.01-1.232.697L5 8.753V12a.5.5 0 0 1-1 0z" />
                </svg></a></li>
            <li @click="prevPage()"><a><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                </svg></a></li>
            <li v-for="pageNumber in visiblePages" :key="pageNumber" :class="{ active: pageNumber === currentPage }"
              class="ellipsis-icon" @click="gotoPage(pageNumber)">
              <template v-if="pageNumber === 'dots'">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-three-dots" viewBox="0 0 16 16">
                    <path
                      d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3" />
                  </svg>
                </span>
              </template>
              <template v-else>
                <a>{{ pageNumber }}</a>
              </template>
            </li>

            <li @click="nextPage()"><a><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                </svg></a></li>
            <li @click="gotoPage(totalPages)"><a><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                  fill="currentColor" class="bi bi-skip-end-fill" viewBox="0 0 16 16">
                  <path
                    d="M12.5 4a.5.5 0 0 0-1 0v3.248L5.233 3.612C4.693 3.3 4 3.678 4 4.308v7.384c0 .63.692 1.01 1.233.697L11.5 8.753V12a.5.5 0 0 0 1 0z" />
                </svg></a></li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Filter from '@/components/Filter.vue';
import editIcon from '@/components/edit-icon.vue';
import tableHeadingIcon from '@/components/table-heading-icon.vue';
import { getAsset } from "@/http/iot-asset/asset.http"
export default {
  name: "asset",
  components: {
    Header,
    Filter,
    editIcon,
    tableHeadingIcon
  },
  data() {
    return {
      breadcrumsfirst: "IoT Assets",
      breadcrumslast: "Asset",
      filterConfig: {
        buttonConfig: {
          show: true,
          link: '/iotassets/asset/add'
        }
      },
      tableData: [],
      currentPage: 1,
      pageSize: 5,
      totalCount: 0,
      pageSizeOptions: [5, 10, 20], // Define your options for items per page
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.pageSize);
    },
    visiblePages() {
      const totalVisiblePages = 3; // Change this as needed
      const pages = [];
      let startPage = 1;
      let endPage = this.totalPages;

      if (this.totalPages > totalVisiblePages) {
        const halfVisiblePages = Math.floor(totalVisiblePages / 2);
        startPage = Math.max(this.currentPage - halfVisiblePages, 1);
        endPage = startPage + totalVisiblePages - 1;

        if (endPage > this.totalPages) {
          startPage -= endPage - this.totalPages;
          endPage = this.totalPages;
        }

        if (startPage > 1) {
          pages.push(1);
          if (startPage > 2) {
            pages.push('dots');
          }
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (endPage < this.totalPages) {
        if (endPage < this.totalPages - 1) {
          pages.push('dots');
        }
        pages.push(this.totalPages);
      }

      return pages;
    }
  },
  methods: {
    fetchData() {
      getAsset({
        index: this.currentPage,
        pagesize: this.pageSize
      })
        .then(response => {
          this.tableData = response.data;
          this.totalCount = response.recordcount.totalcount;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    },
    gotoPage(pageNumber) {
      if (pageNumber >= 1 && pageNumber <= this.totalPages) {
        this.currentPage = pageNumber;
        this.fetchData();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchData();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchData();
      }
    },
    changePageSize() {
      this.currentPage = 1; // Reset to the first page when changing page size
      this.fetchData();
    }
  },
  mounted() {
    this.fetchData();
  }

};
</script>

<style></style>